import template from './wegbewijzering.html';
import controller from './wegbewijzering.controller';
import './wegbewijzering.scss';

let wegbewijzeringComponent = {
  bindings: {
    article: '<'
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default wegbewijzeringComponent;



// WEBPACK FOOTER //
// ./client/app/components/content-types/wegbewijzering/wegbewijzering.component.js